import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Table, Button, Form, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Get, Post } from '../../../../utils/httpProvider';
import { LICHHOCTHUCHANH_API } from '../../../../utils/apiUrl';
import moment from 'moment';
import BoSungHocVienModal from './BoSungHocVienModal';

const DiemDanhTab = ({ contractId }) => {
    const [selectedNgay, setSelectedNgay] = useState(moment().format('YYYY-MM-DD'));
    const [loading, setLoading] = useState(false);
    const [attendanceData, setAttendanceData] = useState({ hocViens: [] });
    const [changedItems, setChangedItems] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Fetch dữ liệu phiên điểm danh theo ngày đã chọn
    useEffect(() => {
        if (contractId) {
            fetchDiemDanhSession();
        }
    }, [contractId, selectedNgay]);

    const fetchDiemDanhSession = async () => {
        setLoading(true);
        setChangedItems({});
        try {
            const res = await Get(`${LICHHOCTHUCHANH_API.GET_DIEM_DANH_SESSION}?ngay=${selectedNgay}`);
            const resolvedSession = res || { hocViens: [] };
            resolvedSession.hocViens = resolvedSession.hocViens?.$values || resolvedSession.hocViens || [];
            setAttendanceData(resolvedSession);
        } catch (err) {
            toast.error("Không thể lấy danh sách điểm danh.");
        } finally {
            setLoading(false);
        }
    };

    // Khi chọn trạng thái điểm danh cho 1 học viên
    const handleStatusChange = (hocVienLinkId, status) => {
        setChangedItems(prev => ({
            ...prev,
            [hocVienLinkId]: status
        }));
    };

    // Điểm danh có mặt nhanh cho toàn bộ học viên chưa điểm danh và chưa bị disable
    const handleCheckAllPresent = () => {
        const updates = {};
        attendanceData.hocViens.forEach(hv => {
            if (!hv.isDisabled && !hv.laNgoaiLich && hv.trangThai === null && changedItems[hv.hopDongChiTietHocVienId] === undefined) {
                updates[hv.hopDongChiTietHocVienId] = 1; // 1 = Có mặt
            }
        });

        if (Object.keys(updates).length === 0) {
            toast.info("Không có học viên nào khả dụng để điểm danh nhanh.");
            return;
        }

        setChangedItems(prev => ({ ...prev, ...updates }));
        toast.success(`Đã tích Có mặt nhanh cho ${Object.keys(updates).length} học viên.`);
    };

    // Hủy bổ sung học viên ngoài lịch
    const handleHuyBoSung = async (diemDanhId) => {
        if (!window.confirm("Bạn chắc chắn muốn hủy ghi nhận học viên ngoài lịch này?")) return;

        try {
            const res = await Post(`${LICHHOCTHUCHANH_API.HUY_BO_SUNG_HOC_VIEN}/${diemDanhId}`);
            if (res || res?.success) {
                toast.success("Đã hủy bổ sung học viên thành công.");
                fetchDiemDanhSession();
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message || "Đã xảy ra lỗi khi kết nối server.");
        }
    };

    // Lưu điểm danh tập trung lên Backend
    const handleSaveAttendance = async () => {
        const itemsToSave = Object.entries(changedItems).map(([id, status]) => {
            const hv = attendanceData.hocViens.find(x => x.hopDongChiTietHocVienId === id);
            return {
                hopDongChiTietHocVienId: id,
                lichHocThucHanhId: hv ? (hv.lichThucTeId || hv.lichGocId) : null,
                trangThai: status,
                ghiChu: ""
            };
        }).filter(item => item.lichHocThucHanhId !== null);

        if (itemsToSave.length === 0) {
            toast.info("Chưa có thay đổi điểm danh nào để lưu.");
            return;
        }

        setSubmitting(true);
        try {
            const payload = {
                lichHocThucHanhId: null,
                ngayThucTe: selectedNgay,
                items: itemsToSave
            };

            const res = await Post(LICHHOCTHUCHANH_API.SAVE_DIEM_DANH, null, payload);
            if (res || res?.success) {
                toast.success("Lưu điểm danh thành công.");
                setChangedItems({});
                fetchDiemDanhSession();
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message || "Lỗi lưu dữ liệu.");
        } finally {
            setSubmitting(false);
        }
    };

    const hasSchedulesInDay = attendanceData.hocViens.some(x => !x.laNgoaiLich);
    const countChanges = Object.keys(changedItems).length;

    return (
        <div className="py-3">
            <style>{`
                .attendance-table th {
                    background-color: #f8fafc;
                    color: #0f766e;
                    font-weight: 700;
                    border-bottom: 2px solid #cbd5e1;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                }
                .attendance-table td {
                    vertical-align: middle;
                    font-size: 0.85rem;
                }
                .disabled-row {
                    opacity: 0.6;
                    background-color: #f1f5f9;
                }
            `}</style>

            <Card className="p-3 mb-4 shadow-sm border-light">
                <Row className="align-items-center">
                    <Col xs={12} md={6} className="d-flex align-items-center flex-wrap" style={{ gap: '15px' }}>
                        <div className="d-flex align-items-center">
                            <span className="mr-2 font-weight-bold text-muted small text-uppercase">Ngày:</span>
                            <Form.Control
                                type="date"
                                size="sm"
                                value={selectedNgay}
                                onChange={(e) => setSelectedNgay(e.target.value)}
                                style={{ borderRadius: '6px', width: '160px' }}
                            />
                        </div>
                        {attendanceData.giangVienTen && (
                            <div className="small text-muted">
                                Giảng viên thực hiện: <strong className="text-primary">{attendanceData.giangVienTen}</strong>
                            </div>
                        )}
                    </Col>
                    <Col xs={12} md={6} className="text-md-right mt-3 mt-md-0 d-flex justify-content-start justify-content-md-end align-items-center flex-wrap" style={{ gap: '10px' }}>
                        {hasSchedulesInDay && (
                            <>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={handleCheckAllPresent}
                                    disabled={loading}
                                    style={{ borderRadius: '6px', fontWeight: '500', whiteSpace: 'nowrap' }}
                                >
                                    <i className="fas fa-check-circle mr-1"></i> Có mặt nhanh
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={handleSaveAttendance}
                                    loading={submitting}
                                    disabled={loading || countChanges === 0}
                                    style={{ borderRadius: '6px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                                >
                                    <i className="fas fa-save mr-1"></i> Lưu điểm danh ({countChanges})
                                </Button>
                            </>
                        )}
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => setModalVisible(true)}
                            disabled={loading || !hasSchedulesInDay}
                            style={{ borderRadius: '6px', fontWeight: '500', whiteSpace: 'nowrap' }}
                        >
                            <i className="fas fa-user-plus mr-1"></i> Bổ sung học viên
                        </Button>
                    </Col>
                </Row>
            </Card>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-teal spinner-border-sm mr-2" role="status"></div>
                    <span className="text-muted font-weight-bold">Đang tải danh sách điểm danh...</span>
                </div>
            ) : (
                <div className="table-responsive border rounded-lg shadow-sm" style={{ background: '#fff' }}>
                    <Table className="attendance-table mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '5%', textAlign: 'center' }}>STT</th>
                                <th style={{ width: '25%' }}>Học viên</th>
                                <th style={{ width: '20%' }}>Chuyên ngành</th>
                                <th style={{ width: '35%' }}>Điểm danh thực tế</th>
                                <th style={{ width: '15%', textAlign: 'center' }}>Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceData.hocViens.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center py-4 text-muted">
                                        Không có lịch giảng dạy kế hoạch nào được ghi nhận trong ngày này.
                                    </td>
                                </tr>
                            ) : (
                                attendanceData.hocViens.map((hv, idx) => {
                                    const currentStatus = changedItems[hv.hopDongChiTietHocVienId] !== undefined
                                        ? changedItems[hv.hopDongChiTietHocVienId]
                                        : hv.trangThai;

                                    return (
                                        <tr key={hv.hopDongChiTietHocVienId} className={hv.isDisabled ? "disabled-row" : ""}>
                                            <td style={{ textAlign: 'center' }} className="font-weight-bold">{idx + 1}</td>
                                            <td>
                                                <span className="font-weight-bold text-dark">{hv.hocVienTen}</span>
                                                {hv.laNgoaiLich ? (
                                                    <Badge bg="warning" className="text-white ml-2">Ngoài lịch</Badge>
                                                ) : (
                                                    <Badge bg="success" className="text-white ml-2">Theo lịch</Badge>
                                                )}
                                            </td>
                                            <td>{hv.chuyenNganh}</td>
                                            <td>
                                                {hv.isDisabled ? (
                                                    <span className="text-danger font-italic small font-weight-bold">
                                                        <i className="fas fa-exclamation-circle mr-1"></i> {hv.canhBao}
                                                    </span>
                                                ) : hv.laNgoaiLich ? (
                                                    <span className="badge badge-warning text-white py-2 px-3" style={{ fontSize: '0.85rem' }}>
                                                        <i className="fas fa-check-circle mr-1"></i> Có mặt (Ngoài lịch)
                                                    </span>
                                                ) : (
                                                    <div className="btn-group shadow-xs" role="group">
                                                        <Button
                                                            variant={currentStatus === 1 ? 'success' : 'outline-secondary'}
                                                            size="sm"
                                                            onClick={() => handleStatusChange(hv.hopDongChiTietHocVienId, 1)}
                                                            style={{ borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px', fontSize: '0.75rem', fontWeight: '500' }}
                                                        >
                                                            <i className="fas fa-user-check mr-1"></i> Có mặt
                                                        </Button>
                                                        <Button
                                                            variant={currentStatus === 3 ? 'warning' : 'outline-secondary'}
                                                            size="sm"
                                                            onClick={() => handleStatusChange(hv.hopDongChiTietHocVienId, 3)}
                                                            style={{ borderRadius: '0', fontSize: '0.75rem', fontWeight: '500' }}
                                                        >
                                                            <i className="fas fa-user-clock mr-1"></i> Vắng phép
                                                        </Button>
                                                        <Button
                                                            variant={currentStatus === 4 ? 'danger' : 'outline-secondary'}
                                                            size="sm"
                                                            onClick={() => handleStatusChange(hv.hopDongChiTietHocVienId, 4)}
                                                            style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', fontSize: '0.75rem', fontWeight: '500' }}
                                                        >
                                                            <i className="fas fa-user-times mr-1"></i> Vắng KP
                                                        </Button>
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {hv.laNgoaiLich && hv.diemDanhId && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        style={{ borderRadius: '6px' }}
                                                        onClick={() => handleHuyBoSung(hv.diemDanhId)}
                                                    >
                                                        <i className="fas fa-trash-alt mr-1"></i> Hủy bổ sung
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </div>
            )}

            <BoSungHocVienModal
                show={modalVisible}
                onHide={() => setModalVisible(false)}
                contractId={contractId}
                currentLichId={attendanceData.hocViens.find(x => !x.laNgoaiLich)?.lichThucTeId}
                ngayDiemDanh={selectedNgay}
                onSuccess={fetchDiemDanhSession}
            />
        </div>
    );
};

export default DiemDanhTab;
